import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
  data: [],
  page: 1,
  pageSize: 10,
  totalCount: 0,
  totalPages: 0,
  find: null,
  params: {},
};

export default function arqueacoes(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@arqueacoes/FIND_ARQUEACAO':
      case '@arqueacoes/UPDATE_ARQUEACAO':
      case '@arqueacoes/DELETE_ARQUEACAO':
      case '@arqueacoes/STORE_ARQUEACAO':
      case '@arqueacoes/ARQUEACOES_IN_REQUEST': {
        draft.loading = true;
        break;
      }

      case '@arqueacoes/SUCCESS_REMOVE':
      case '@arqueacoes/FAILED_REQUEST': {
        draft.loading = false;
        break;
      }

      case '@arqueacoes/SUCCESS_IN_REQUEST': {
        draft.loading = false;
        draft.data = action.payload.arqueacoes;
        draft.page = action.payload.page;
        draft.pageSize = action.payload.pageSize;
        draft.totalCount = action.payload.totalCount;
        draft.totalPages = action.payload.totalPages;
        draft.find = {};
        break;
      }

      case '@arqueacoes/SUCCESS_REQUEST': {
        draft.loading = false;
        draft.find = action.payload.arqueacao;
        break;
      }

      case '@arqueacoes/RECORD_FILTERING': {
        draft.loading = true;
        //draft.params = { ...draft.params, ...action.payload.params };
        draft.params = action.payload.params;
        break;
      }

      case '@hooks/RESET': {
        draft.data = [];
        draft.page = 1;
        draft.pageSize = 10;
        draft.totalCount = 0;
        draft.totalPages = 0;
        draft.find = null;
        draft.params = {};
        break;
      }

      default:
    }
  });
}
